import Vue from 'vue';
import VueI18n from 'vue-i18n';
import iView from 'view-design';
// import { locale } from 'view-design';

import { cookieService } from '@/service/cookie.service';

import iviewEN from 'view-design/dist/locale/en-US';
import iviewVI from 'view-design/dist/locale/vi-VN';
import iviewJA from 'view-design/dist/locale/ja-JP';

const ja = require('./ja.json');
const en = require('./en.json');
const vi = require('./vi.json');
const es_419 = require('./es-419.json');
const pt_BR = require('./pt-BR.json');

Vue.use(VueI18n);

export const setIViewLocale = () => {
  const langCode: string = cookieService.language || 'ja';
  switch (langCode) {
    case 'ja': {
      const fixDatepicker = iviewJA.i.datepicker;
      fixDatepicker.clear = 'クリア';
      fixDatepicker.selectDate = '日付選択';
      fixDatepicker.selectTime = '時間選択';
      iView.locale(iviewJA);
      break;
    }
    case 'en': {
      const fixDatepicker = iviewEN.i.datepicker;
      fixDatepicker.clear = 'clear';
      fixDatepicker.selectDate = 'select date';
      fixDatepicker.selectTime = 'select time';
      iView.locale(iviewEN);
      break;
    }
    case 'vi': {
      break;
    }
  }
};

setIViewLocale();

export default new VueI18n({
  locale: cookieService.language || 'ja',
  fallbackLocale: 'en',
  messages: {
    ja,
    en,
    vi,
    'es-419': es_419,
    'pt-BR': pt_BR,
  },
});
